<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col
        v-if="monitoramento === 'mapeamento'"
        cols="4"
      >
        <app-select-mapeamento
          :mapeamento="mapeamento"
          :mapeamentos="mapeamentos"
          @return="(value) => (mapeamento = value)"
        />
      </v-col>
      <v-col
        v-if="monitoramento === 'diagnostico' || monitoramento === 'desempenho'"
        cols="4"
      >
        <v-select
          v-model="diagnostico"
          :items="diagnosticos"
          item-text="nome"
          item-value="id"
          label="Diagnóstico:"
          return-object
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="6">
                <span class="font-weight-bold">{{ labelMonitoramento }}: </span>
                <span class="font-weight-light">{{ nomeMonitoramento }}</span>
              </v-col>
              <v-col
                v-if="monitoramento === 'diagnostico' && diagnostico"
                cols="6"
              >
                <span class="font-weight-bold">Período: </span>
                <span class="font-weight-light">{{ periodoDiagnostico }}</span>
              </v-col>
              <v-col
                v-if="monitoramento === 'perfil'"
                cols="6"
              >
                <span class="font-weight-bold">Unidade: </span>
                <span class="font-weight-light">{{
                  `${unidade.sigla} - ${unidade.nome}`
                }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget
          :enable-actions="actions"
          :title="titulo ? titulo : 'Relatório'"
        >
          <div slot="widget-content">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  absolute
                  color="secondary"
                  dark
                  fab
                  right
                  top
                  @click="loadTutorial"
                  v-on="on"
                >
                  <v-icon>help</v-icon>
                </v-btn>
              </template>
              <span>Em caso de dúvidas, clique aqui</span>
            </v-tooltip>
            <v-row no-gutters>
              <!-- Slot Body -->
              <slot name="body" />
            </v-row>
          </div>
          <div slot="widget-actions">
            <v-row no-gutters>
              <v-col cols="12">
                <!-- Slot Actions-->
                <slot name="actions" />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppSelectMapeamento from '@/components/core/AppSelectMapeamento';
import Data from '@/modules/data';

export default {
  name: 'AppMonitoramento',

  components: { VCardWidget, AppSelectMapeamento },

  props: {
    titulo: {
      type: String,
      default: '',
    },
    actions: {
      type: Boolean,
      default: false,
    },
    acesso: {
      type: String,
      default: null,
    },
    monitoramento: {
      type: String,
      default: null,
    },
    perspectiva: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      getMapeamento: 'mapeamento/getMapeamento',
      getMapeamentos: 'mapeamento/getMapeamentos',
      getDiagnostico: 'diagnostico/getDiagnostico',
      getDiagnosticos: 'diagnostico/getDiagnosticos',
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    ...mapState({
      unidade: (state) => state.auth.unidade,
    }),
    mapeamento: {
      get() {
        return this.getMapeamento(this.acesso);
      },
      set(mapeamento) {
        const payload = { tipo: this.acesso, mapeamento };
        this.$store.dispatch('mapeamento/setMapeamento', payload);
      },
    },
    mapeamentos() {
      return this.getMapeamentos(this.acesso);
    },
    diagnostico: {
      get() {
        return this.getDiagnostico(this.acesso);
      },
      set(diagnostico) {
        if (this.acesso === 'COMUM') {
          this.$store.dispatch('diagnostico/setDiagnostico', diagnostico);
        } else if (this.acesso === 'COMISSAO') {
          this.$store.dispatch('diagnostico/setDiagnosticoComissao', diagnostico);
        }
      },
    },
    diagnosticos() {
      return this.getDiagnosticos(this.acesso);
    },
    labelMonitoramento() {
      if (this.monitoramento === 'mapeamento') {
        return 'Mapeamento';
      }
      if (this.monitoramento === 'diagnostico' || this.monitoramento === 'desempenho') {
        return 'Diagnóstico';
      }
      return 'Usuário(a)';
    },
    nomeMonitoramento() {
      if (this.monitoramento === 'mapeamento') {
        return this.mapeamento && this.mapeamento.nome ? this.mapeamento.nome : '';
      }
      if (this.monitoramento === 'diagnostico' || this.monitoramento === 'desempenho') {
        return this.diagnostico && this.diagnostico.nome ? this.diagnostico.nome : '';
      }
      return this.$store.state.auth.usuario.nome;
    },
    periodoDiagnostico() {
      if (this.diagnostico) {
        let inicio;
        let fim;
        const { inicioComportamental } = this.diagnostico;
        const inicioTecnico = this.diagnostico.inicioResponsabilidadeChefia;
        const { fimComportamental } = this.diagnostico;
        const fimTecnico = this.diagnostico.inicioResponsabilidadeServidor;

        if (Data.compare('isBefore', { a: inicioComportamental, b: inicioTecnico })) {
          inicio = Data.format(inicioComportamental);
        } else {
          inicio = Data.format(inicioTecnico);
        }

        if (Data.compare('isAfter', { a: fimComportamental, b: fimTecnico })) {
          fim = Data.format(fimComportamental);
        } else {
          fim = Data.format(fimTecnico);
        }

        return `${inicio} a ${fim}`;
      }
      return '';
    },
    unidadesByAcesso() {
      return this.getUnidadesByAcesso(this.acesso, this.diagnostico.mapeamento.id);
    },
  },

  created() {
    if (!this.acesso) {
      this.$router.push('/403');
    }
  },

  methods: {
    loadTutorial() {
      let tutorial = '';
      switch (this.$route.name) {
        case 'MonitoramentoMapeamentoEstruturaUnidades':
          tutorial = 'MonitoramentoMapeamentoEstruturaUnidades';
          break;
        case 'MonitoramentoMapeamentoComportamental':
          if (this.$store.state.monitoramento.mapeamento.unidades.length > 1) {
            tutorial = 'MonitoramentoMapeamentoGeralComportamental';
          } else {
            tutorial = 'MonitoramentoMapeamentoUnidadeComportamental';
          }
          break;
        case 'MonitoramentoMapeamentoResponsabilidade':
          if (this.$store.state.monitoramento.mapeamento.unidades.length > 1) {
            tutorial = 'MonitoramentoMapeamentoGeralResponsabilidade';
          } else {
            tutorial = 'MonitoramentoMapeamentoUnidadeResponsabilidade';
          }
          break;
        case 'MonitoramentoDiagnosticoComportamental':
          tutorial = 'MonitoramentoDiagnosticoComportamental';
          break;
        case 'MonitoramentoDiagnosticoTecnico':
          tutorial = 'MonitoramentoDiagnosticoTecnico';
          break;
        case 'MonitoramentoDesempenhoComportamental':
          if (this.unidadesByAcesso.length > 1) {
            tutorial = 'MonitoramentoDesempenhoGeralComportamental';
          } else {
            tutorial = 'MonitoramentoDesempenhoUnidadeComportamental';
          }
          break;
        case 'MonitoramentoDesempenhoResponsabilidade':
          if (this.unidadesByAcesso.length > 1) {
            tutorial = 'MonitoramentoDesempenhoGeralResponsabilidade';
          } else {
            tutorial = 'MonitoramentoDesempenhoUnidadeResponsabilidade';
          }
          break;
        case 'MonitoramentoCoeficienteDesempenho':
          if (this.unidadesByAcesso.length > 1) {
            tutorial = 'MonitoramentoCoeficienteDesempenhoGeral';
          } else {
            tutorial = 'MonitoramentoCoeficienteDesempenhoUnidade';
          }
          break;
        case 'MonitoramentoPerfilFiltro':
          tutorial = 'MonitoramentoPerfilFiltrosBusca';
          break;
        case 'MonitoramentoPerfilRelatorio':
          tutorial = 'MonitoramentoPerfilRelatoriosGerenciais';
          break;
        default:
          tutorial = '';
      }
      this.$store.dispatch('app/showTutorial', { nome: tutorial });
    },
  },
};
</script>
